import {
  defineStyleConfig,
  StyleThemingProps,
  useStyleConfig,
} from '@chakra-ui/react'
import { Size } from '~/types/ThemeTypes'

import { getName } from '@mangovoice/core'

import { sharedComponentColorKeys } from './_colors'

const Colors = sharedComponentColorKeys.LoadingSpinner

export const enum LoadingSpinnerStyleProperties {
  color = 'color',
  trackColor = 'trackColor',
  size = 'size',
}

export const LoadingSpinnerStyle = defineStyleConfig({
  baseStyle: {
    [LoadingSpinnerStyleProperties.color]: Colors.color,
    [LoadingSpinnerStyleProperties.trackColor]: Colors.trackColor,
  },
  sizes: {
    [Size.sm]: {
      [LoadingSpinnerStyleProperties.size]: '2rem',
    },
    [Size.md]: {
      [LoadingSpinnerStyleProperties.size]: '4rem',
    },
    [Size.lg]: {
      [LoadingSpinnerStyleProperties.size]: '6.25rem',
    },
  },
  defaultProps: {
    [LoadingSpinnerStyleProperties.size]: Size.md,
  },
})

export const useLoadingSpinnerStyle = (props?: StyleThemingProps) => {
  return useStyleConfig(getName({ LoadingSpinnerStyle }), props)
}
